/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Give_TInputs */

const en_cp_lead_give_t = /** @type {(inputs: Cp_Lead_Give_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we ask per semester`)
};

const id_cp_lead_give_t = /** @type {(inputs: Cp_Lead_Give_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang kami minta per semester`)
};

/**
* | output |
* | --- |
* | "What we ask per semester" |
*
* @param {Cp_Lead_Give_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_give_t = /** @type {((inputs?: Cp_Lead_Give_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Give_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_give_t(inputs)
	return en_cp_lead_give_t(inputs)
});